














































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import _ from "lodash";
import expandRow from "./preorder-shorted-sku-expand.vue";
class PagePreorderShortedSkuBySoRequestCodesRequest extends PageRequest {
  keyword: string;
  warehouseCode: string;
}

@Component({
  components: { expandRow },
})
export default class ViewPreorderShortedSkuBySoRequestCodes extends AbpBase {
  namespace = "preorderShortedSku";
  //filters
  pagerequest: PagePreorderShortedSkuBySoRequestCodesRequest = new PagePreorderShortedSkuBySoRequestCodesRequest();
  list = [];
  warehouses = [];
  get store() {
    return this.$store.state.preorderShortedSku;
  }
  get totalItems() {
    var argus = ["0"];
    if (!Util.isNull(this.list)) {
      argus = [this.list.length.toString()];
    }
    return Util.L("TotalItems", "", ...argus);
  }
  get loading() {
    return this.store.loading;
  }
  isTenant() {
    return this.$store.state.session.tenant != null;
  }
  get tenant() {
    return this.$store.state.session.tenant;
  }
  async getWarehouses() {
    await this.$store
      .dispatch({
        type: "warehouse/getListForSelect",
        data: { hasAllItem: true },
      })
      .then(() => {
        var re = this.$store.state.warehouse.warehousesForSelect;
        this.pagerequest.warehouseCode = re.length === 0 ? "" : re[0].id;
        this.warehouses = re;
      });
  }
  async getPage() {
    if (Util.isNull(this.pagerequest.keyword)) return;
    if (this.isTenant()) {
      this.pagerequest.warehouseCode = this.tenant.tenancyName;
    }
    this.list = await this.$store.dispatch({
      type: `${this.namespace}/getAllPreOrderShortedSkuBySoRequestCodes`,
      data: this.pagerequest,
    });
  }
  async exportAllPreOrderShortQtyBySoRequestCodeToExcel() {
    await this.$store.dispatch({
      type: `${this.namespace}/exportAllPreOrderShortQtyBySoRequestCodeToExcel`,
      data: {
        keyWord: Util.isNull(this.pagerequest.keyword)
          ? ""
          : this.pagerequest.keyword,
        warehouseCode: this.pagerequest.warehouseCode,
      },
    });
  }
  async exportAllPreOrderSaleOrderShortedSkuBySoRequestCodeToExcel(row: any) {
    await this.$store.dispatch({
      type: `${
        this.namespace
      }/exportAllPreOrderSaleOrderShortedSkuBySoRequestCodeToExcel`,
      data: {
        productId: row.id,
        keyWord: Util.isNull(this.pagerequest.keyword)
          ? ""
          : this.pagerequest.keyword,
        warehouseCode: this.pagerequest.warehouseCode,
      },
    });
  }
  async created() {
    await this.getWarehouses();
  }
  columns = [
    {
      type: "expand",
      width: 50,
      render: (h, params) => {
        return h(expandRow, {
          props: {
            row: params.row,
          },
        });
      },
    },
    {
      title: Util.L("Warehouse"),
      key: "warehouseName",
    },
    {
      title: Util.L("Client"),
      key: "clientName",
    },
    {
      title: Util.L("SKU"),
      key: "sku",
    },
    {
      title: Util.L("ProductName"),
      key: "name",
    },
    {
      title: Util.L("ShortQty"),
      key: "shortQty",
      align: "right",
      render: (h, params) => {
        return h("span", Util.toViewNumberString(params.row.shortQty));
      },
    },
    {
      title: Util.L("Action"),
      slot: "action",
      align: "center",
    },
  ];
}
